import { FC } from 'react';
import styles from "./MobileStudioContent.module.css";
import Samples from '../../../RightButtons/Samples';
import Scenes from '../../../RightButtons/ScenesElements';
import Tabs from '../../../../../components/Tabs';
import { UserStudio } from '../../../../../features/api/apiSlice';

interface MobileStudioContentProps {
  backgrounds?: UserStudio["backgrounds"];
  logos?: UserStudio["logos"];
  studio?: UserStudio;
  isLoadingTemplates: boolean;
  templatesError: any;
  studioTemplates: any[];
}

const MobileStudioContent: FC<MobileStudioContentProps> = ({
  backgrounds,
  logos,
  studio,
  isLoadingTemplates,
  templatesError,
  studioTemplates,
}) => {
  return (
    <div className={styles["content-library"]}>
      <Tabs items={[
        {
          title: "Фоны",
          component:
            <div className={styles["content-library__tab"]}>
              <Scenes background={backgrounds} logos={logos} studio={studio} />
            </div>
        },
        {
          title: "Шаблоны",
          component:
            <div className={styles["content-library__tab"]}>
              <Samples
                isLoading={isLoadingTemplates}
                error={templatesError}
                templates={studioTemplates || []}
              />
            </div>
        }
      ]} />
    </div>
  );
};

export default MobileStudioContent;